import React from 'react';
import createReactClass from 'create-react-class';
import BaseMixin from './BaseMixin';
import StringCompareTerminalMixin from './StringCompareTerminalMixin';
import Select2 from "shared/react_components/Select2";

const AdwordsData = createReactClass({
  displayName: 'AdwordsData',
  mixins: [BaseMixin, StringCompareTerminalMixin],

  render: function() {
    return (
      <form className="form-inline">
        { this.renderTerminalName() }
        { this._renderAdwordsParamName() }
        { this.renderRelOp() }
        { this.renderValue() }
      </form>
    );
  },

  defaultValue: function() {
    "";
  },

  _adwordsParams: function() {
    return [
      { id: 'referrer_campaign', text: 'Campaign' },
      { id: 'referrer_campaign_id', text: 'Campaign ID' },
      { id: 'ad_group', text: 'Ad Group' },
      { id: 'ad_group_id', text: 'Ad Group ID' },
      { id: 'ad', text: 'Ad' },
      { id: 'ad_id', text: 'Ad ID' },
      { id: 'search_keywords', text: 'Keywords' },
      { id: 'search_keywords_id', text: 'Keywords ID' },
      { id: 'keyword_match_type', text: 'Keyword Match Type' }
    ];
  },

  selectChangeListener: function(data) {
    this.props.node.set("adwords_data_name", data.id);
  },

  _renderAdwordsParamName: function() {
    // initialize the text if model is already set
    var initialValue = this.props.node.get('adwords_data_name');
    if (initialValue) {
      this.props.node.set("adwords_data_name_label", initialValue, { silent: true });
    }

    if (this.props.editable) {
      return (
        <Select2
          uniqueNameField='adwords_data_name'
          friendlyNameField='text'
          node={ this.props.node }
          values={ this._adwordsParams() }
          changeListener={ this.selectChangeListener }
          style={ { marginRight: '5px' } }
        />
      );
    } else {
      return this._renderReadonlyValue(initialValue);
    }
  }
});

export default AdwordsData;
